import * as React from 'react'
import styled from 'styled-components'

import ResponsiveImage from 'components/Common/ResponsiveImage'
import GoogleCardImage from 'tripPlanner/components/ItemCard/Common/GoogleCardImage'
import type { TripItem } from 'tripPlanner/types/tripItem'
import { getItemPlace } from 'tripPlanner/utils'
import { rem } from 'polished'

const BaseContainer = styled.div`
  position: absolute;
  width: ${rem(56)};
  height: ${rem(56)};
  border-radius: ${props => props.theme.borderRadius.M};
  overflow: hidden;

  @container (min-width: 640px) {
    width: 100%;
    height: 100%;

    /* calc - 1px to avoid gap with the container border*/
    &:not(.showComment) {
      border-radius: calc(${props => props.theme.borderRadius.L} - 1px) 0 0 calc(${props => props.theme.borderRadius.L} - 1px);
    }

    &.showComment {
      border-radius: calc(${props => props.theme.borderRadius.L} - 1px) 0 0 0;
    }
  }
`

const Image = styled.img`
  object-fit: cover;
  object-position: center;
  height: 100%;
  width: 100%;
`

interface Props {
  item: TripItem
  name: string
  /** URL of external image */
  imgSrc?: string
  /** ID of image from svc-image */
  imgId?: string
  placeId?: string
  className?: string
}

function ItemCardImage({ item, name, imgId, imgSrc, placeId, className }: Props) {
  const place = getItemPlace(item, 'start')

  let imageElement: React.ReactNode

  if (imgId) {
    imageElement = (
      <ResponsiveImage
        fit="center"
        id={imgId}
      />
    )
  } else if (imgSrc) {
    imageElement = <Image src={imgSrc} />
  } else if (placeId) {
    imageElement = (
      <GoogleCardImage
        placeId={placeId}
        title={name}
        tripId={item.tripId}
        tripItemId={item.id}
      />
    )
  } else if (place?.photoUrl) {
    imageElement = <Image src={place.photoUrl} />
  } else {
    return null
  }

  return <BaseContainer className={className}>{imageElement}</BaseContainer>
}

export default ItemCardImage
